import { useInterval } from '@mantine/hooks';
import { FC, useState } from 'react';

import Paragraph from '@/components/text/Paragraph.tsx';

import useBreakpoints from '@/hooks/useBreakpoints.ts';

import { dayjs } from '@/utils/dayjsSetup.ts';

const Clock: FC = () => {
    const { is_xl } = useBreakpoints();
    const [time, setTime] = useState<string>(dayjs().format('HH:mm [Uhr]'));
    const [date, setDate] = useState<string>(dayjs().format('dd, DD. MMM YY'));

    useInterval(
        () => {
            setTime(dayjs().format('HH:mm [Uhr]'));
            setDate(dayjs().format('dd, DD. MMM YY'));
        },
        1000,
        { autoInvoke: true }
    );

    return (
        <div className="flex flex-col gap-1 px-1 xl:flex-row xl:px-6">
            <Paragraph className="text-sm font-medium uppercase tracking-wider text-slate-500">{date}</Paragraph>
            {is_xl && <Paragraph className="text-sm font-medium uppercase tracking-wider text-slate-500">|</Paragraph>}
            <Paragraph className="text-sm font-medium uppercase tracking-wider text-slate-500">{time}</Paragraph>
        </div>
    );
};

export default Clock;
